<template>
  <a-modal
    :title="title"
    :width="800"
    :ok=false
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    @ok="handleOk"
    :okText="this.$store.getters.language['common.okButton']"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['depart.management.departName']"
          prop="departName"
          :hidden="false"
           >
          <a-input  :placeholder="language['common.pleaseInput']+language['depart.management.departName']" v-model="model.departName" style="width: 85%"/>
          <a-button @click="languageModelOpen('SysDepart','departName',departNameLanguages,)" type="primary"  style="left: 3%" >{{language['common.language']}}</a-button>
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="language['depart.management.thirdOrgCode']">
          <a-input :placeholder="language['common.pleaseInput']+language['depart.management.thirdOrgCode']" v-model="model.thirdOrgCode" :maxLength="100"/>
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" :hidden="seen" :label="language['depart.management.FDepart']" hasFeedback>
        <a-tree-select
          style="width:100%"
          :dropdownStyle="{maxHeight:'200px',overflow:'auto'}"
          :treeData="departTree"
          v-model="model.parentId"
          :placeholder="language['common.pleaseInput']+language['depart.management.FDepart']"
          :disabled="condition">
        </a-tree-select>
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['depart.management.orgCategory']">
         <template v-if="seen">
            <a-radio-group v-model="model.orgCategory" :placeholder="language['common.pleaseChoose']+language['depart.management.orgCategory']">
              <a-radio value="1">
                {{language['common.company']}}
              </a-radio>
            </a-radio-group>
          </template>
          <template v-else>
            <a-radio-group v-model="model.orgCategory" :placeholder="language['common.pleaseChoose']+language['depart.management.orgCategory']">
              <a-radio value="2">
                {{language['depart']}}
              </a-radio>
              <a-radio value="3">
                {{language['common.post']}}
              </a-radio>
            </a-radio-group>
       </template>
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="mobile"
          :label="language['depart.management.mobile']">
          <a-input :placeholder="language['common.pleaseInput']+language['depart.management.mobile']" v-model="model.mobile"/>
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['depart.management.fax']">
          <a-input :placeholder="language['common.pleaseInput']+language['depart.management.fax']" v-model="model.fax"/>
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['depart.management.address']">
          <a-input :placeholder="language['common.pleaseInput']+language['depart.management.address']" v-model="model.address"/>
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['common.sort']">
          <a-input-number v-model="model.departOrder"/>
        </a-form-model-item>

        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['depart.management.expenseCode']">
          <a-input :placeholder="language['common.pleaseInput']+language['depart.management.expenseCode']" v-model="model.expenseCode"/>
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="levelNo"
          :label="language['depart.management.levelNo']">
          <j-dict-select-tag v-model="model.levelNo" :placeholder="language['common.pleaseChoose']+language['depart.management.levelNo']" :allowClear="true" :dictCode="levelDictCode" v-if="!!levelDictCode"/>
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['depart.management.deportDirector']">
<!--          <j-select-user :placeholder="language['common.pleaseChoose']+language['depart.management.deportDirector']" :multiple="false" v-model="model.departChief"/>-->
          <j-select-user :placeholder="language['common.pleaseChoose']+language['depart.management.deportDirector']" :multiple="false" v-model="model.departChief" :url="departMangerURL" rowKey="workNo" />
        </a-form-model-item>

        <a-form-model-item
          prop="artificialPerson"
          :label="language['depart.management.artificialPerson']"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol">
          <a-select
            style="width: 100%"
            allowClear
            :placeholder="language['common.pleaseChoose']+language['depart.management.artificialPerson']"
            v-model="model.artificialPerson">
            <a-select-option v-for="(item,index) in artificialPersonList" :key="index.toString()" :value="item.id">
              {{ item.legalpersonName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          prop="siteCode"
          :label="language['depart.management.siteCode']"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol">
          <a-select
            style="width: 100%"
            allowClear
            :placeholder="language['common.pleaseChoose']+language['depart.management.siteCode']"
            v-model="model.siteCode">
            <a-select-option v-for="(item,index) in siteCodeList" :key="index.toString()" :value="item.id">
              {{ item.factoryName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['depart.management.memo']">
          <a-textarea :placeholder="language['common.pleaseInput']+language['depart.management.memo']" v-model="model.memo"/>
        </a-form-model-item>

      </a-form-model>
    </a-spin>
    <language-model ref="languageModel" @ok="languageOk"></language-model>
  </a-modal>
</template>

<script>
  import { httpAction,getAction } from '@/api/manage'
  import { queryIdTree } from '@/api/api'
  import { get, pick } from 'lodash';
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import LanguageModel from "@/components/LanguageModel"
  export default {
    name: "SysDepartModal",
    components: { ATextarea,LanguageModel },
    data () {
      return {
        artificialPersonList:[{
          id:'',
          applicationName:''
        }],
        siteCodeList:[{
          id:'',
          xxx:''
        }],
        departTree:[],
        orgTypeData:[],
        phoneWarning:'',
        departName:"",
        title:this.$store.getters.language['common.action'],
        seen:false,
        visible: false,
        condition:true,
        disableSubmit:false,
        model: {},
        defaultModel:{
          departOrder:0,
          orgCategory:'1'
        },
        menuhidden:false,
        menuusing:true,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },

        confirmLoading: false,
        validatorRules:{
          departName:[{ required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['depart.management.departName'] }],
          // orgCode:[{ required: true, message: '请输入机构编码!' }],
          mobile: [{validator:this.validateMobile}],
          orgCategory:[{required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['depart.management.orgCategory']}],
          departChief:[{ required: true, message: this.$store.getters.language['common.pleaseChoose']+this.$store.getters.language['depart.management.deportDirector'] }],
          levelNo:[{ required: true, message: this.$store.getters.language['common.pleaseChoose']+this.$store.getters.language['depart.management.levelNo'] }],
          // artificialPerson: [{ required: true, message: '请选择法人!' }],
        },
        url: {
          add: "/sys/sysDepart/add",
        },
        dictDisabled:true,
        departMangerURL:'/sys/user/queryList?applicationCode='+this.$store.getters.applicationCode+'&applicationBy=user',
        departNameLanguages:[],
        levelDictCode:'',
      }
    },
    computed:{
      language() {
        return this.$store.getters.language
      },
    },
    created () {
      this.getLegalPersons();
      this.getDepartSites();
      this.getlevelDictCode();
    },
    methods: {
      languageModelOpen(dataTable,dataColumn,languagelist){
        this.$refs.languageModel.edit("platform",dataTable,dataColumn,this.model.id,languagelist);
      },
      languageOk(map){
        if(map&&map.dataColumn == 'departName'){
          this.departNameLanguages = map.languagelist;
        }
      },
      getLegalPersons(){
        getAction("/sys/sysDepart/getLegalPersonList").then((res) => {//{id: this.model.artificialPerson}
          if (res.success) {
            this.artificialPersonList = res.result;
          }
        })
      },
      getDepartSites(){
        getAction("/sys/sysDepart/getFactoryList").then((res) => {//, {id: this.model.siteCode}
          if (res.success) {
            this.siteCodeList = res.result;
          }
        })
      },
      loadTreeData(){
        var that = this;
        queryIdTree().then((res)=>{
          if(res.success){
            that.departTree = [];
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i];
              that.departTree.push(temp);
            }
          }

        })
      },
      initLanguagetemp(dataTable,dataColumn,dataId){
        getAction("/sys/syslanguagedata/querylistby", {applicationCode:"platform",dataTable:dataTable,dataColumn:dataColumn,dataId:dataId}).then((res)=> {
          if (res.success) {
            this.departNameLanguages = res.result;
          }
        })
      },
      add (depart) {
        if(depart){
          this.seen = false;
          this.dictDisabled = false;
        }else{
          this.seen = true;
          this.dictDisabled = true;
        }
        this.edit(depart);
      },
      edit (record) {
          this.visible = true;
          this.model = Object.assign({}, this.defaultModel, record)
          this.loadTreeData();
          this.model.parentId = record!=null?record.toString():null;
           if(this.seen){
             this.model.orgCategory = '1';
           }else{
             this.model.orgCategory = '2';
           }
        this.initLanguagetemp('SysDepart','departName',this.model.id);
      },
      close () {
        this.$emit('close');
        this.disableSubmit = false;
        this.visible = false;
        this.$refs.form.resetFields();
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            this.model.applicationCode=this.$store.getters.applicationCode;
            httpAction(this.url.add,this.model,"post").then((res)=>{
              if(res.success){
                this.departNameLanguages.forEach(item=>{
                  if(!item.dataId){
                    item.dataId = res.result.id;
                  }
                })
                httpAction("/sys/syslanguagedata/saveSysLanguageDataList",this.departNameLanguages,"post").then((res)=>{
                  if(res.success){
                    that.$message.success(res.message);
                    that.loadTreeData();
                    that.$emit('ok');
                  }
                })
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })

          }else{
            return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
      validateMobile(rule,value,callback){
        if (!value || new RegExp(/^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/).test(value)){
          callback();
        }else{
          callback(this.language['portal.interface.phone.format.incorrect']);
        }

      },
      getlevelDictCode(){
        getAction("/sys/sysDepart/getApplicationLevel", {applicationCode:this.$store.getters.applicationCode}).then((res)=> {
          if (res.success) {
            this.levelDictCode = res.result;
          }else{
            this.levelDictCode = "depart_category";
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>